import { createContext, useContext } from 'react'
import { ProductWithRecommendations } from '../../components/ProductDetails'
import { ProductDetailsContext, ProductDetailsState } from './types'
import { DepartmentInfo } from '../../types'

export const initialProductState: ProductDetailsState = {
  product: {} as ProductWithRecommendations,
  upsellProduct: undefined,
  selectedOptions: {
    variantKey: '',
    quantity: 1,
    addonSku: null,
  },
  departmentInfo: {} as DepartmentInfo,
}

export const productContext = createContext<ProductDetailsContext>([
  initialProductState,
  /* istanbul ignore next */ () => {},
])

export const useProductContext = () => {
  return useContext(productContext)
}
